module.exports = __webpack_public_path__ + "img/content_credentials_icon.32030f4d.svg";